export default __webpack_public_path__ + "static/media/10percent.f2fd71aa.svg";